"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNotEmpty = isNotEmpty;
exports.emptyProps = void 0;
var emptySymbol = Symbol('emptyProps');
var emptyProps = function () {
  var obj = {};
  Object.defineProperty(obj, '$$empty', {
    value: emptySymbol,
    enumerable: false
  });
  obj = Object.freeze(obj);
  return obj;
}();
exports.emptyProps = emptyProps;
function isNotEmpty(p) {
  //@ts-ignore
  return !!p && p.$$empty !== emptySymbol;
}